import { useCreation } from 'ahooks'

import { useRouterStore } from '@eastcoal/router/components/Store/hooks/useStore'

import { ResourceBaseTree } from '../ResourceBaseTree'

import { ResourceTreeProps } from './interface'
import { transformResourceTreeData } from './utils/transformTreeData'

export const ResourceTree = ({
  checkable = true,
  onlyShowChecked = false,
  ...restProps
}: ResourceTreeProps) => {
  const restrictedResources = useRouterStore(state => state.restrictedResources)
  const transformedResource = useCreation(
    () => transformResourceTreeData(restrictedResources),
    [restrictedResources]
  )
  return (
    <ResourceBaseTree
      {...restProps}
      checkable={checkable}
      data={transformedResource}
      onlyShowChecked={onlyShowChecked}
    />
  )
}
